import { convertToSeconds, oneHour, oneDay, floorToMidnight } from '../../utils/time';

// enum ForecastChartType (as per the schema)
export const ForecastChartType = {
  WAVE: 'WAVE_V3',
  PERIOD: 'PERIOD_V2',
  WIND: 'WIND',
  PRESSURE: 'PRESSURE',
  JET_STREAM: 'JET_STREAM',
  SEA_ICE: 'SEA_ICE',
  SST: 'SST',
};

export const getChartTimes = (type, numberOfDays) => {
  const startOfToday = convertToSeconds(floorToMidnight(Date.now()));
  const startOfYesterday = startOfToday - convertToSeconds(oneDay);
  let start;
  let end;

  // The most recent SST tileset will be the day before the current UTC day,
  // so requests should be in the past, and the window big enough to account
  // for any delays to data
  //
  // Follow a similar process for SEA_ICE
  if (type === ForecastChartType.SST || type === ForecastChartType.SEA_ICE) {
    start = startOfToday - (convertToSeconds(oneDay) * 3);
    end = startOfToday;

  // Otherwise, requests should be N days plus three hours in length starting from
  // 00:00 of the day of request.
  // Note the additional 3 hours is to ensure the 00:00 tile of the 17th day is included,
  // otherwise, it will actually be 15 days and 18 hours worth of data, which we don't want.
  } else {
    start = startOfYesterday;
    end = startOfToday
      + (convertToSeconds(oneDay) * (numberOfDays + 1))
      + (convertToSeconds(oneHour) * 3);
  }
  return [start, end];
};

export const tilesetQuery = (type, start, end) => (`
  query {
    forecastCharts(type: ${type}, start: ${start}, end: ${end}) {
      type
      tiles {
        id
        timestamp
      }
    }
  }
`);



// WEBPACK FOOTER //
// ./src/common/graphql/charts.js